// ----------------------------------------------------------------------------
// Template: Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import '../../sections/header/header';
import '../../snippets/pagination/pagination';
import '../../sections/page-header/page-header';
import '../../sections/blog-posts/blog-posts';
import '../../sections/recipe-search/recipe-search';
import '../../sections/footer/footer';

// Styles
import './_blog.scss';
